import { createElement } from "react";
import { createObj } from "../fable_modules/fable-library-js.4.28.0/Util.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { map, singleton, ofArray } from "../fable_modules/fable-library-js.4.28.0/List.js";
import { singleton as singleton_1, append, delay, toList } from "../fable_modules/fable-library-js.4.28.0/Seq.js";
import { t as t_1 } from "../Lang.js";
import { Contact_title, Nav_logout, Nav_login, Help_title } from "../Shared/Tr.js";
import { Msg } from "../App/Messages.js";
import { AdSlot } from "./AdSlot.js";
import { View } from "./HelpView.js";
import { toastContainer } from "./Components.js";

function langSwitcher() {
    let elems;
    return createElement("select", createObj(ofArray([["className", "lang-switcher"], ["value", localStorage.getItem('lang') || navigator.language?.slice(0,2) || 'en'], ["onChange", (ev) => {
        const v = ev.target.value;
        localStorage.setItem('lang', v);
        location.reload();
    }], (elems = [createElement("option", {
        value: "en",
        children: "🇬🇧 EN",
    }), createElement("option", {
        value: "sv",
        children: "🇸🇪 SV",
    }), createElement("option", {
        value: "de",
        children: "🇩🇪 DE",
    }), createElement("option", {
        value: "fr",
        children: "🇫🇷 FR",
    }), createElement("option", {
        value: "es",
        children: "🇪🇸 ES",
    }), createElement("option", {
        value: "it",
        children: "🇮🇹 IT",
    }), createElement("option", {
        value: "pt",
        children: "🇵🇹 PT",
    }), createElement("option", {
        value: "nl",
        children: "🇳🇱 NL",
    }), createElement("option", {
        value: "da",
        children: "🇩🇰 DA",
    }), createElement("option", {
        value: "nb",
        children: "🇳🇴 NO",
    }), createElement("option", {
        value: "pl",
        children: "🇵🇱 PL",
    }), createElement("option", {
        value: "cs",
        children: "🇨🇿 CS",
    }), createElement("option", {
        value: "ro",
        children: "🇷🇴 RO",
    }), createElement("option", {
        value: "hu",
        children: "🇭🇺 HU",
    }), createElement("option", {
        value: "hr",
        children: "🇭🇷 HR",
    }), createElement("option", {
        value: "sk",
        children: "🇸🇰 SK",
    }), createElement("option", {
        value: "bg",
        children: "🇧🇬 BG",
    }), createElement("option", {
        value: "el",
        children: "🇬🇷 EL",
    }), createElement("option", {
        value: "tr",
        children: "🇹🇷 TR",
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function navbar(user, dispatch) {
    let elems_1, children, elems;
    return createElement("header", createObj(ofArray([["className", "app-header"], (elems_1 = [(children = singleton(createElement("a", {
        href: "/",
        children: "WhoSitsWhere",
    })), createElement("h1", {
        children: reactApi.Children.toArray(Array.from(children)),
    })), createElement("div", createObj(ofArray([["className", "nav-user"], (elems = toList(delay(() => append(singleton_1(createElement("button", {
        className: "help-header-btn",
        title: t_1(Help_title),
        onClick: (_arg) => {
            dispatch(new Msg(268, ["index", undefined]));
        },
        children: "?",
    })), delay(() => append(singleton_1(langSwitcher()), delay(() => {
        const matchValue = user;
        return (matchValue == null) ? singleton_1(createElement("a", {
            href: "#/login",
            children: t_1(Nav_login),
        })) : append(singleton_1(createElement("a", {
            href: "#/account",
            className: "nav-user-name",
            children: matchValue.Name,
        })), delay(() => singleton_1(createElement("button", {
            className: "btn btn-sm btn-secondary",
            children: t_1(Nav_logout),
            onClick: (_arg_1) => {
                dispatch(new Msg(7, []));
            },
        }))));
    })))))), ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function toastLevelClass(level) {
    switch (level.tag) {
        case 1:
            return "toast toast-error";
        case 2:
            return "toast toast-warning";
        case 3:
            return "toast toast-info";
        default:
            return "toast toast-success";
    }
}

export function mainLayout(user, helpPanel, toasts, dispatch, content) {
    let elems_2, elems_1;
    const toastTuples = map((t) => [t.Id, toastLevelClass(t.Level), t.Message], toasts);
    return createElement("div", createObj(ofArray([["className", "app-layout"], (elems_2 = [navbar(user, dispatch), createElement("main", {
        className: "app-content",
        children: reactApi.Children.toArray([content]),
    }), createElement("footer", createObj(ofArray([["className", "app-footer-ad"], (elems_1 = [createElement("a", {
        href: "#/contact",
        className: "footer-contact-link",
        children: t_1(Contact_title),
    }), createElement(AdSlot, {
        adSlotId: "XXXXXXXXXX",
        adFormat: "horizontal",
        cssClass: "ad-slot-footer",
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), createElement(View, {
        panel: helpPanel,
        dispatch: dispatch,
    }), toastContainer(toastTuples, (id) => {
        dispatch(new Msg(274, [id]));
    })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

